export const subdomains = {
  groupSurveyLogin: 'grupowe',
};
